import { render, staticRenderFns } from "./OrdersConfig.vue?vue&type=template&id=30ed837a&scoped=true"
import script from "./OrdersConfig.vue?vue&type=script&lang=js"
export * from "./OrdersConfig.vue?vue&type=script&lang=js"
import style0 from "./OrdersConfig.vue?vue&type=style&index=0&id=30ed837a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed837a",
  null
  
)

export default component.exports